/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { DeleteOrganizationMutationResponse, DeleteOrganizationPathParams, DeleteOrganization400, DeleteOrganization401, DeleteOrganization403, DeleteOrganization404, DeleteOrganization409, DeleteOrganization500 } from "../../types/organizationController/DeleteOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getDeleteOrganizationUrl(organizationId: DeleteOrganizationPathParams["organizationId"]) {
  const res = { method: 'DELETE', url: `/api/organizations/${organizationId}` as const }
  return res
}

/**
 * @summary Delete organization
 * {@link /api/organizations/:organizationId}
 */
export async function deleteOrganization(organizationId: DeleteOrganizationPathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteOrganizationMutationResponse, ResponseErrorConfig<DeleteOrganization400 | DeleteOrganization401 | DeleteOrganization403 | DeleteOrganization404 | DeleteOrganization409 | DeleteOrganization500>, unknown>({ method : "DELETE", url : getDeleteOrganizationUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}